<template>
	<div>
		<el-dialog :visible.sync="codedialog" :width="$store.state.width>$store.state.minwidth?'500px':($store.state.width-12+'px')" @opened="opened()">
			<my-qrcode v-if="codedialog" :ids="id+'big'" :url="window.location.protocol+'//'+window.location.host+'/details?code='+id" :iconurl="config.apiurl+$store.state.main.user.avatar" :wid="460" :hei="460" :imgwid="100" :imghei="100"></my-qrcode>
		</el-dialog>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item>溯源记录</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :md="14">
				<el-col :md="14">
					<el-input v-model="find" placeholder="请输入内容" :size="$store.state.width<$store.state.minwidth?'small':'medium'">
						<el-button slot="append" icon="el-icon-search" @click="Find()">搜索</el-button>
					</el-input>
				</el-col>
			</el-col>
			<el-col :md="10" v-show="$store.state.width>$store.state.minwidth" class="output">
				<el-button type="primary" icon="el-icon-paperclip" size="medium" @click="exportExcel()">导出</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-table id="table" :data="$store.state.traceability.archives.list" size="mini" stripe border class="table">
					<el-table-column type="index" width="40"></el-table-column>
					<el-table-column prop="alias" label="名称"></el-table-column>
					<el-table-column prop="soleno" label="编号"></el-table-column>
					<el-table-column prop="guid" label="溯源码"></el-table-column>
					<el-table-column prop="csexName" label="性别" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<el-table-column prop="price" label="价值" v-if="$store.state.width>$store.state.minwidth">
						<template slot-scope="scope">
							<span>{{scope.row.price}}元/斤</span>
						</template>
					</el-table-column>
					<el-table-column prop="id" label="二维码" width="90">
						<template slot-scope="scope">
							<div @click="opencode(scope.row.guid)">
								<my-qrcode :ids="scope.row.guid" :url="window.location.protocol+'//'+window.location.host+'/details?code='+scope.row.guid" :iconurl="config.apiurl+$store.state.main.user.avatar" :wid="70" :hei="70" :imgwid="20" :imghei="20"></my-qrcode>
							</div>
							<!-- <vue-qr :text="window.location.protocol+'//'+window.location.host+'/details?code='+scope.row.guid" :logoScale="10" :size="60" :margin="0"></vue-qr> -->
							<!-- <canvas @click="opencode(scope.row.guid)" :id="'canvas' + scope.row.id" class="sy-code"></canvas> -->
						</template>
					</el-table-column>
					<el-table-column prop="id" label="操作" width="80">
						<template slot-scope="scope">
							<el-button type="infor" size="mini" @click="look(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="pagin">
			<el-col :span="24">
				<div>
					<el-pagination background :small="$store.state.width<$store.state.minwidth" align="center" @size-change="changeSize" @current-change="nextpage" :current-page="$store.state.production.page" :page-sizes="[20, 50, 100, 200]" :page-size="$store.state.production.pagesize" :layout="$store.state.width>$store.state.minwidth?'total, sizes, prev, pager, next, jumper':'prev, pager, next'" :total="$store.state.traceability.archives.page.total"></el-pagination>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import FileSaver from 'file-saver';
	import XLSX from 'xlsx';
	import QRCode from 'qrcode';
	import qrcode from 'vue_qrcodes';
	export default {
		data() {
			return {
				find: '',
				codedialog: false,
				id: 0,
				window: window
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal){
					
				}
			}
		},
		components: {
			qrcode
		},
		mounted: function () {
			// this.window=window;
			this.$store.commit('pagesize',20);
			this.$store.commit('page',1);
			this.load();
		},
		updated: function(){
			this.useqrcode();
		},
		methods: {
			load()
			{
				this.$store.commit('mainload',true);
				this.getarchives()
				.then(()=>{
					this.$store.commit('mainload',false);
				});
			},
			useqrcode(){
				// for(let i=0;i<this.$store.state.traceability.archives.list.length;i++)
				// {
				// 	let canvas = document.getElementById('canvas'+this.$store.state.traceability.archives.list[i].id);
				// 	QRCode.toCanvas(canvas, window.location.protocol+"//"+window.location.host+"/details?code="+this.$store.state.traceability.archives.list[i].guid);
				// }
			},
			look(item)
			{
				window.open("/details?code="+item.guid, '_blank');
			},
			opencode(id)
			{
				this.codedialog=true;
				this.id=id;
			},
			opened()
			{
				let canvas = document.getElementById('canvasdialog');
				QRCode.toCanvas(canvas, window.location.protocol+"//"+window.location.host+"/details?code="+this.id);
			},
			changeSize(val) {
				this.$store.commit('pagesize',val);
				this.$store.commit('page',1);
				this.load();
			},
			nextpage(val) {
				this.$store.commit('page',val);
				this.load();
			},
			Find()
			{
				let value={
					keyword: this.find
				};
				this.$store.commit('page',1);
				this.getarchives(value);
			},
			exportExcel() {
				/* npm install --save xlsx file-saver 需要获取依赖 */
				var wb = XLSX.utils.table_to_book(document.querySelector('.table'))
				/* get binary string as output */
				var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
				try {
					FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
				} catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
				this.$message({message: '导出成功！',type: 'success'});
				return wbout
			}
		}
	}
</script>

<style scoped>
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.output{
		text-align: right;
	}
	.table{
		margin-top: 10px;
		width: 100%;
	}
	.add{
		margin-top: 1px;
		margin-left: 5px;
	}
	.pagin{
		margin-top: 10px;
	}
	.fm-img{
		width: 100px;
		height: 100px;
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}
		.slot_table{
		border: 1px solid #EBEEF5;
		border-collapse: collapse ;
	}
	.slot_table>.el-form-item {
		margin-bottom: 0px;
		color: #1991FA;
	}
	.slot_form{
		width: 70%;
		margin: 0 auto;
	}
	.lable_name{
		vertical-align: middle;
		float: left;
		font-size: 14px;
		color: #606266;
		line-height: 40px;
		padding: 0 12px 0 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 30%;
		padding-left: 0.75rem;
		/* border-right: 1px solid #EBEEF5; */
	}
	.lable_value{
		line-height: 40px;
		float: left;
		font-size: 14px;
		color: #1991FA;
		width: 70%;
		text-align: center;
	}
	.sy-code{
		width: 60px !important;
		height: 60px !important;
	}
	.sy-code-dialog{
		width: 460px !important;
		height: 460px !important;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.slot_form{
			width: 100%;
		}
		.sy-code-dialog{
			width: 100% !important;
			height: auto !important;
		}
	}
</style>

<style>
	.el-message-box {
		width: 350px !important;
	}
</style>